const richTextEditorConfig = {
  fontFamilySettings: {
    default: "Segoe UI",
    items: [
      {
        text: "Segoe UI", value: "Segoe UI", class: "e-segoe-ui", command: "Font", subCommand: "FontName",
      },
      {
        text: "Calibri", value: "Calibri", command: "Font", subCommand: "FontName",
      },
      {
        text: "Impact", value: "Impact,Charcoal,sans-serif", class: "e-impact", command: "Font", subCommand: "FontName",
      },
      {
        text: "Sans-Serif", value: "sans-serif", class: "e-sans-serif", command: "Font", subCommand: "FontName",
      },
      {
        text: "Tahoma", value: "Tahoma,Geneva,sans-serif", class: "e-tahoma", command: "Font", subCommand: "FontName",
      },
    ],
  },
  quickToolbarSettings: {
    image: [
      'Replace', 'Align', 'Caption', 'Remove', 'InsertLink', 'OpenImageLink', '-',
      'EditImageLink', 'RemoveImageLink', 'Display', 'AltText', 'Dimension',
    ],
  },
  toolbarSettings: {
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
      'LowerCase', 'UpperCase', '|',
      'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
      'Outdent', 'Indent', '|',
      'CreateLink', 'Image', '|', 'ClearFormat', 'Print',
      'SourceCode', '|', 'Undo', 'Redo',
    ],
  },

};
export default richTextEditorConfig;
